"use strict";

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWSClient = exports.createIPCClient = exports.createClient = void 0;

var api_client_1 = require("./api_client");

var ipc_channel_1 = require("./ipc_channel");

var ws_channel_1 = require("./ws_channel");

var createClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(channel) {
    var client;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = new api_client_1.APIClient(channel);
            _context.next = 3;
            return client.init();

          case 3:
            return _context.abrupt("return", client);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createClient(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.createClient = createClient;

var createIPCClient = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dataPath) {
    var ipcChannel;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ipcChannel = new ipc_channel_1.IPCChannel(dataPath);
            _context2.next = 3;
            return ipcChannel.connect();

          case 3:
            return _context2.abrupt("return", exports.createClient(ipcChannel));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createIPCClient(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.createIPCClient = createIPCClient;

var createWSClient = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
    var wsChannel;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            wsChannel = new ws_channel_1.WSChannel(url);
            _context3.next = 3;
            return wsChannel.connect();

          case 3:
            return _context3.abrupt("return", exports.createClient(wsChannel));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function createWSClient(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.createWSClient = createWSClient;